import { BANNER_DATA, KERNEL_BANNER_DATA } from "@constants/banner";

// import useLedgerLive from "./useLedgerLive";

const useBanner = (variant = 1) => {
  // const { isLedgerConnected } = useLedgerLive();
  let showBanner = false;
  if (variant === 1) {
    showBanner = !!BANNER_DATA.text;
  } else if (variant === 2) {
    showBanner = !!KERNEL_BANNER_DATA.text1;
  }
  //&& isLedgerConnected;

  return { showBanner };
};

export default useBanner;
